export default __webpack_public_path__ + "static/media/pictogramBeaconControl128.c5573c96.svg";